import {IYear} from '../models/IYearModel';
import * as YearsActions from '../actions/YearsActions';
import {AppState} from './index';
import {createFeatureSelector, createReducer, createSelector, on} from '@ngrx/store';

const initialState: Array<IYear> = [];

export const reducer = createReducer(
  initialState,
  on(YearsActions.retrieveYearsAction, state => [...state]),
  on(YearsActions.yearsReceivedAction, (state, {years}) => [...years]),
  on(YearsActions.retrieveYearsErrorAction, (state, {error}) => {
    // Handle error if needed, for now just return the existing state
    return [...state];
  })
);

export const selectRoot = createFeatureSelector<IYear[]>('years');
export const getYears = createSelector(
  selectRoot,
  state => state
);
